import React from "react";
import { Spinner } from "react-bootstrap";

import { SaudiRiyalLogo } from "../../../../logo/saudiLogo";
import i18n from "../../../../../i18n";
import { getAllOrganization } from "../../../../../models/organization";
import { getAllGroups } from "../../../../../models/groups";
import { getAllAuctionsByGroup } from "../../../../../models/auctions";
import { CircleEqual, Gavel, Megaphone, SaudiRiyalIcon, User, Users } from "lucide-react";
import DashboardCard from "./DashboardCard";

let lang = localStorage.getItem("I18N_LANGUAGE");
export class DashboardIcons extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            input: {},
            dash_panel: true,
            clients: [],
            groups: [],
            auctions: [],
            auction_loader: false,
        };
        this.loadAllGroups = this.loadAllGroups.bind(this);
        this.loadByGroup = this.loadByGroup.bind(this);
        this.loadAuctions = this.loadAuctions.bind(this);
        this.hideSideBar = this.hideSideBar.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.loadAllOrganisation();
        this.loadAllGroups();
    }

    handleChange(event) {
        let input = this.state.input;
        input[event.target.name] = event.target.value;
        this.setState({ input });
        if (event.target.name === "group") {
            this.loadAuctions(this.state.input.group);
        }
        if (event.target.name === "client") {
            this.loadAuctions("0");
            this.loadAllGroups();
        }
        this.loadByGroup();
    }

    async loadAllOrganisation() {
        const response = await getAllOrganization();
        let clients = response.data;
        this.setState({ clients });
    }

    async loadAllGroups() {
        let q = "";
        let { input } = this.state;
        if (input.client) {
            q += `organization=${input.client}`;
        }
        const response = await getAllGroups(q);
        let groups = response.data;
        this.setState({ groups });
    }

    async loadAuctions(group) {
        if (group) {
            this.setState({ auction_loader: true });
            const response = await getAllAuctionsByGroup(group);
            if (response.data) {
                this.setState({ auction_loader: false });
                this.setState({ auctions: response.data });
            }
        }
    }

    loadByGroup() {
        this.props.loadByGroup(this.state.input);
    }

    hideSideBar() {
        this.props.hideSideBar(!this.props.is_side_bar);
    }

    render() {
        let { clients, groups, auctions } = this.state;
        return (
            <React.Fragment>
                <div className="card">
                    <div className="card-header d-flex justify-content-between gap-3 align-items-center">
                        {/** onClick={() => {
            this.setState({
              dash_panel: !this.state.dash_panel,
            });
          }}
          role="button" */}
                        <span
                            style={{ fontSize: "1rem", marginRight: "0.5rem" }}
                            onClick={this.hideSideBar}
                        >
                            {this.props.is_side_bar && <i className="icon-size-actual"></i>}
                            {!this.props.is_side_bar && (
                                <i className="icon-size-fullscreen"></i>
                            )}
                        </span>
                        <select
                            className="form-control textbox fs15 text-gray filter-icon"
                            data-placeholder="Select Client"
                            name="client"
                            value={this.state.input.client}
                            onChange={this.handleChange}
                            style={{ width: "33%" }}
                        >
                            <option value="">{i18n.t("select_client")}</option>
                            {clients.length > 0 &&
                                clients.map((item) => {
                                    return (
                                        <option value={item.id} key={item.id}>
                                            {item.organization_name}
                                        </option>
                                    );
                                })}
                        </select>
                        <select
                            className="form-control textbox fs15 text-gray filter-icon"
                            data-placeholder="Select Group"
                            name="group"
                            value={this.state.input.group}
                            onChange={this.handleChange}
                            style={{ width: "33%" }}
                        >
                            <option value="">{i18n.t("select_group")}</option>
                            {groups.length > 0 &&
                                groups.map((item) => {
                                    return (
                                        <option value={item.id} key={item.id}>
                                            {lang === "ar" &&
                                                item.group_name_ar &&
                                                item.group_name_ar !== "null"
                                                ? item.group_name_ar
                                                : item.group_name}
                                        </option>
                                    );
                                })}
                        </select>

                        <select
                            className="form-control textbox fs15 text-gray filter-icon"
                            data-placeholder="Select Class"
                            name="auction"
                            value={this.state.input.auction}
                            onChange={this.handleChange}
                            style={{ width: "33%" }}
                        >
                            <option value="">
                                {!this.state.auction_loader
                                    ? i18n.t("auctions")
                                    : i18n.t("loading..")}
                            </option>
                            {!this.state.auction_loader &&
                                auctions.length > 0 &&
                                auctions.map((item) => {
                                    return (
                                        <option value={item.id} key={item.id}>
                                            {lang === "ar" ? item.title_ar : item.title}
                                        </option>
                                    );
                                })}
                        </select>

                        <span>
                            {this.props.dd_loading && (
                                <Spinner animation="border" size="sm" />
                            )}
                            {!this.props.dd_loading && (
                                <i
                                    className="glyphicon glyphicon-refresh display-5"
                                    onClick={this.loadByGroup}
                                />
                            )}
                        </span>
                    </div>

                    <div className="p-2 rounded-4 m-3" style={{backgroundColor:'#fcfcfc'}}>
                        <div className="grid_container_below" >

                            <DashboardCard
                                className="approved"
                                icon={Gavel}
                                title={i18n.t('active_auctions')}
                                 dd_loading={this.props.dd_loading }
                                value={!this.props.dd_loading && this.props.active_auctions}
                            />

                            <DashboardCard
                                className="approved"
                                icon={User}
                                title={i18n.t('active_bidders')}
                                 dd_loading={this.props.dd_loading }
                                value={!this.props.dd_loading && this.props.active_bidders}
                            />

                            <DashboardCard
                                className="approved"
                                icon={Users}
                                title={i18n.t('total_bidders')}
                                 dd_loading={this.props.dd_loading }
                                value={!this.props.dd_loading && this.props.total_bidders}
                            />

                            <DashboardCard
                                className="approved"
                                icon={CircleEqual}
                                title={i18n.t('total_bids')}
                                dd_loading={this.props.dd_loading }
                                value={!this.props.dd_loading && this.props.total_bids}
                            />

                            <DashboardCard
                                className="approved"
                                icon={SaudiRiyalIcon}
                                title={i18n.t('total_amount')}
                                 dd_loading={this.props.dd_loading }
                                value={!this.props.dd_loading && this.props.total_amount}
                            />
                             <DashboardCard
                                className="approved"
                                icon={ Megaphone}
                                title={i18n.t('auction_in_bidding')}
                                 dd_loading={this.props.dd_loading }
                                value={!this.props.dd_loading && this.props.auction_in_bidding}
                            />

                              <DashboardCard
                                className="approved"
                                icon={SaudiRiyalIcon}
                                title={i18n.t('maximum_bid_amount')}
                                 dd_loading={this.props.dd_loading }
                                value={!this.props.dd_loading && this.props.maximum_bid_amount}
                            />

                            {/* <div className="color-light-blue outer_circle flex_container">
                                <div className="color-green inner_circle">
                                    <Gavel width="35"
                                        height="35" color="white" />
                                </div>
                                <div>
                                    <span>{i18n.t("active_auctions")}</span>
                                    <span>
                                        {this.props.dd_loading && (
                                            <Spinner animation="grow" size="sm" />
                                        )}
                                        {!this.props.dd_loading && this.props.active_auctions}
                                    </span>
                                </div>
                            </div> */}

                            {/* <div className="color-light-blue outer_circle flex_container">
                                <div className="color-orange inner_circle">
                                    <User width="35"
                                        height="35" color="white" />
                                </div>
                                <div>
                                    <span>{i18n.t("active_bidders")}</span>
                                    <span>
                                        {this.props.dd_loading && (
                                            <Spinner animation="grow" size="sm" />
                                        )}
                                        {!this.props.dd_loading && this.props.active_bidders}
                                    </span>
                                </div>
                            </div> */}

                            {/* <div className="color-light-blue outer_circle flex_container">
                                <div className="color-purple inner_circle">
                                    <Users width="35"
                                        height="35" color="white" />
                                </div>
                                <div>
                                    <span>{i18n.t("total_bidders")}</span>
                                    <span>
                                        {this.props.dd_loading && (
                                            <Spinner animation="grow" size="sm" />
                                        )}
                                        {!this.props.dd_loading && this.props.total_bidders}
                                    </span>
                                </div>
                            </div> */}

                            {/* <div className="color-light-blue outer_circle flex_container">
                                <div className="color-red inner_circle">
                                    <img
                                        width="35"
                                        height="35"
                                        src={
                                            process.env.PUBLIC_URL +
                                            "/assets/images/carbon_cost-total.png"
                                        }
                                        alt=""
                                    />
                                </div>
                                <div>
                                    <span>{i18n.t("total_bids")}</span>
                                    <span>
                                        {this.props.dd_loading && (
                                            <Spinner animation="grow" size="sm" />
                                        )}
                                        {!this.props.dd_loading && this.props.total_bids}
                                    </span>
                                </div>
                            </div> */}

                            {/* <div className="color-light-blue outer_circle flex_container">
                                <div className="color-blue inner_circle">

                                    <SaudiRiyalLogo color="white" height={35} width={35} />
                                </div>
                                <div>
                                    <span>{i18n.t("total_amount")}</span>
                                    <span>
                                        {this.props.dd_loading && (
                                            <Spinner animation="grow" size="sm" />
                                        )}
                                        {!this.props.dd_loading && this.props.total_amount}
                                    </span>
                                </div>
                            </div> */}

                            {/* <div className="color-light-blue outer_circle flex_container">
                                <div className="color-yellow inner_circle">
                                    <Megaphone width="35"
                                        height="35" color="white" />
                                </div>
                                <div>
                                    <span>{i18n.t("auction_in_bidding")}</span>
                                    <span>
                                        {this.props.dd_loading && (
                                            <Spinner animation="grow" size="sm" />
                                        )}
                                        {!this.props.dd_loading && this.props.auction_in_bidding}
                                    </span>
                                </div>
                            </div> */}

                            {/* <div className="color-light-blue outer_circle flex_container">
                                <div className="color-pink inner_circle">
                                    <img
                                        width="35"
                                        height="35"
                                        src={
                                            process.env.PUBLIC_URL +
                                            "/assets/images/fa6-solid_hand-holding-dollar.png"
                                        }
                                        alt=""
                                    />
                                </div>
                                <div>
                                    <span>{i18n.t("maximum_bid_amount")}</span>
                                    <span>
                                        {this.props.dd_loading && (
                                            <Spinner animation="grow" size="sm" />
                                        )}
                                        {!this.props.dd_loading && this.props.maximum_bid_amount}
                                    </span>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
